import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ListaItem } from '../../../_models/lista-item';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ListaService } from '../../../_services/lista.service';
import {forkJoin, of} from 'rxjs';
import { ProductoAutorizacionService } from '../../../_services/producto-autorizacion.service';
import { Plantilla } from '../../../_models/plantilla';
import { PlantillaService } from '../../../_services/plantilla.service';
import { ProductoAutorizacion } from '../../../_models/producto-autorizacion';
import { ModalidadAutorizacionService } from '../../../_services/modalidad-autorizacion.service';
import {TiposProductosBancarios} from '../../../_enums/enum';

@Component({
  selector: 'app-producto-autorizacion',
  templateUrl: 'producto-autorizacion.component.html',
  styleUrls: ['producto-autorizacion.component.scss']
})

export class ProductoAutorizacionComponent implements OnInit {
  @Input() producto: Producto;
  listaAutorizaciones: SelectItem[] = [];
  listaPlantillas: SelectItem[] = [];
  lisFases: SelectItem[] = [];
  listaAutorizacionesTodos: any[] = [];
  listaPlantillasTodos: any[] = [];
  carInformacionInicial = true;
  listaProductosAutorizaciones: ProductoAutorizacion[] = [];
  listaProductosAutorizacionesTodos: ProductoAutorizacion[] = [];
  listaProAutorizacionesNormales: ProductoAutorizacion[] = [];
  listaProAutorizacionesContrato: ProductoAutorizacion[] = [];
  acordeonesActivos: number[] = [];
  formulario: FormGroup;
  submitted = false;
  columnas: any[];
  lisFasesTodas: ListaItem[] = [];

  constructor(
    private proAutorizacionServicio: ProductoAutorizacionService,
    private navServicio: NavService,
    private fb: FormBuilder,
    private location: Location,
    private conServicio: ConfirmationService,
    private plantillaServicio: PlantillaService,
    private modAutorizacionServicio: ModalidadAutorizacionService,
    private lisServicio: ListaService) {
  }

  ngOnInit(): void {
    this.cargarFormulario();
    this.columnas = [
      { field: 'nombreAutorizacion', header: this.navServicio.buscarMensaje('PRODUCTOAUTORIZACION.LBL_AUTORIZACION'), sort: true },
      { field: 'descripcion', header: this.navServicio.buscarMensaje( 'FLUJOVENTAAUTORIZACIONES.LBL_DESCRIPCION' ), sort: false },
      { field: 'nombrePlantilla', header: this.navServicio.buscarMensaje('PRODUCTOAUTORIZACION.LBL_PLANTILLA'), sort: true },
      { field: 'fase', header: this.navServicio.buscarMensaje('PRODUCTOAUTORIZACION.LBL_FASE'), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje('LBL_ACCIONES'), sort: false }
    ];

    forkJoin(
      this.proAutorizacionServicio.listadoPorProducto(this.producto.idProducto),
      this.lisServicio.getMasterDetails('ListasAutorizaciones'),
      this.plantillaServicio.getAllEnabled(),
      this.producto.codigoTipoProductoBancario == TiposProductosBancarios.CREDITO ? this.modAutorizacionServicio.listadoModalidadesAutorizacionesHabilitadasIdModalidad(this.producto.idModalidad) : of([]),
      this.lisServicio.getMasterDetails('ListasFases'),
    ).subscribe(([listaProAutorizaciones, listaAutorizaciones, listaPlantillas, lisModalidadAutorizacion, lisFases]) => {
      this.listaProductosAutorizacionesTodos = listaProAutorizaciones;
      this.lisFasesTodas = lisFases;
      this.listaPlantillasTodos = listaPlantillas;
      this.listaAutorizacionesTodos = this.producto.codigoTipoProductoBancario == TiposProductosBancarios.CREDITO ? listaAutorizaciones.filter(x => lisModalidadAutorizacion.find(y => y.idAutorizacion === x.idLista)) : listaAutorizaciones;
      this.cargarProductoAutorizaciones();
      this.cargarAutorizaciones();
      this.cargarPlantillas();
      this.cargarFases();
      this.cargarFormulario();
      this.carInformacionInicial = false;
    });
  }

  /*get productosAutorizaciones() {
    return this.listaProductosAutorizacionesTodos.filter( x => x.indicadorHabilitado );
  }*/

  // cargarDropdown() {
  //   const lista = this.listaProductosAutorizacionesTodos.filter( x => x.indicadorHabilitado );
  //   this.listaPlantillasTodos.map( x => {
  //     const temp = lista.find( a => a.idPlantilla === x.idPlantilla );
  //     if ( !temp ) {
  //       this.listaPlantillas.push( { label: x.nombre, value: x.idPlantilla } );
  //     }
  //   } );
  //   this.listaAutorizacionesTodos.map( x => {
  //     const temp = lista.find( a => a.idAutorizacion === x.idLista );
  //     if ( !temp ) {
  //       this.listaAutorizaciones.push( { label: x.nombre, value: x.idLista } );
  //     }
  //   } );
  // }

  /**
   * Construye el formulario de autorización de producto, incluyendo el indicador de aplica contrato (por defecto false).
   */
  cargarFormulario() {
    this.formulario = this.fb.group({
      idProductoAutorizacion: [null],
      idProducto: [this.producto.idProducto, [Validators.required]],
      idAutorizacion: [null, [Validators.required]],
      idPlantilla: [null, [Validators.required]],
      idFase: [null, [Validators.required]],
      indicadorAplicaContrato: [false],
      indicadorHabilitado: [true],
      auditoriaUsuario: [null],
      auditoriaFecha: [null],
      descripcion: [ null ],
    });
  }

  get f() {
    return this.formulario.controls;
  }

  /**
   * Crea la autorización o reactiva la existente con la misma autorización y fase.
   * Siempre envía indicadorAplicaContrato porque el PUT reemplaza el registro completo.
   */
  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      const autorizacion = this.formulario.value;
      autorizacion.indicadorAplicaContrato = !!autorizacion.indicadorAplicaContrato;
      this.carInformacionInicial = true;
      const exiFase = this.listaProductosAutorizacionesTodos.find(x => x.idFase == autorizacion.idFase && x.idAutorizacion == autorizacion.idAutorizacion);
      if (exiFase && exiFase.indicadorHabilitado) {
        this.navServicio.setMesage(0, {
          severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('PRODUCTOAUTORIZACION.MSG_YAEXISTEFASE')
        });
        this.carInformacionInicial = false;
      } else if (exiFase) {
        exiFase.idPlantilla = autorizacion.idPlantilla;
        exiFase.descripcion = autorizacion.descripcion !== null ? autorizacion.descripcion.trim(): null;
        if (exiFase.descripcion === "") {
          exiFase.descripcion = null;
        }
        exiFase.indicadorAplicaContrato = autorizacion.indicadorAplicaContrato;
        exiFase.indicadorHabilitado = true;
        this.proAutorizacionServicio.actualizar(exiFase).subscribe(conActualizada => {
          const d = this.listaPlantillasTodos.find(x => x.idPlantilla === autorizacion.idPlantilla);
          if (d) {
            exiFase.nombrePlantilla = d.nombre;
          }
          this.cargarProductoAutorizaciones();
          this.cargarPlantillas();
          // this.cargarAutorizaciones();
          this.formulario.reset();
          this.f.idProducto.setValue(this.producto.idProducto);
          this.f.indicadorHabilitado.setValue(true);
          this.f.indicadorAplicaContrato.setValue(false);
          this.submitted = false;
          this.carInformacionInicial = false;
          this.navServicio.setMesage(1);
        }, error => {
          this.carInformacionInicial = false;
          this.navServicio.setMesage(3);
        });
      } else {
        this.proAutorizacionServicio.crear(autorizacion).subscribe(autNueva => {
          autorizacion.idProductoAutorizacion = autNueva.idProductoAutorizacion;
          const d = this.listaPlantillasTodos.find(x => x.idPlantilla === autorizacion.idPlantilla);
          if (d) {
            autorizacion.nombrePlantilla = d.nombre;
          }
          const e = this.listaAutorizacionesTodos.find(x => x.idLista === autorizacion.idAutorizacion);
          if (e) {
            autorizacion.nombreAutorizacion = e.nombre;
          }
          const f = this.lisFasesTodas.find(y => y.idLista === autorizacion.idFase);
          if (f) {
            autorizacion.fase = f.nombre;
          }
          this.listaProductosAutorizacionesTodos.push(autorizacion);
          this.cargarProductoAutorizaciones();
          this.cargarPlantillas();
          // this.cargarAutorizaciones();
          this.formulario.reset();
          this.f.idProducto.setValue(this.producto.idProducto);
          this.f.indicadorHabilitado.setValue(true);
          this.f.indicadorAplicaContrato.setValue(false);
          this.submitted = false;
          this.carInformacionInicial = false;
          this.navServicio.setMesage(1);
        }, error => {
          this.carInformacionInicial = false;
          this.navServicio.setMesage(3);
        });
      }
    }
  }

  inhabilitar(proAutorizacion: ProductoAutorizacion) {
    this.conServicio.confirm({
      message: this.navServicio.buscarMensaje('MSG_INHABILITAR'),
      header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'controles',
      accept: () => {
        this.carInformacionInicial = true;
        proAutorizacion.indicadorHabilitado = false;
        this.proAutorizacionServicio.actualizar(proAutorizacion).subscribe(regActualizado => {
          this.cargarProductoAutorizaciones();
          // this.cargarAutorizaciones();
          this.cargarPlantillas();
          this.cargarFormulario();
          this.navServicio.setMesage(2);
          this.carInformacionInicial = false;
        });
      },
      reject: () => {
      }
    });
  }

  cargarFases() {
    this.lisFases = [];
    this.lisFasesTodas.map((s: ListaItem) => {
      this.lisFases.push({ label: s.nombre, value: s.idLista });
    });
  }

  cargarAutorizaciones() {
    this.listaAutorizaciones = [];
    this.listaAutorizacionesTodos.map((s: ListaItem) => {
      /*if ( !this.listaProductosAutorizaciones.find( y => y.idAutorizacion === s.idLista ) ) {
        this.listaAutorizaciones.push( { label: s.nombre, value: s.idLista } );
      }*/
      this.listaAutorizaciones.push({ label: s.nombre, value: s.idLista });
    });
  }

  cargarPlantillas() {
    this.listaPlantillas = [];
    this.listaPlantillasTodos.map((s: Plantilla) => {
      if (s.indicadorHabilitado && !this.listaProductosAutorizaciones.find(y => y.idPlantilla === s.idPlantilla)) {
        this.listaPlantillas.push({ label: s.nombre, value: s.idPlantilla });
      }
    });
  }

  /**
   * Filtra las autorizaciones habilitadas y las separa en normales y de contrato según indicadorAplicaContrato.
   */
  cargarProductoAutorizaciones() {
    this.listaProductosAutorizaciones = this.listaProductosAutorizacionesTodos.filter(x => x.indicadorHabilitado);
    this.listaProAutorizacionesNormales = this.listaProductosAutorizaciones.filter(x => !x.indicadorAplicaContrato);
    this.listaProAutorizacionesContrato = this.listaProductosAutorizaciones.filter(x => x.indicadorAplicaContrato);
  }

}
